export default "__VITE_ASSET__CSrJztvf__"